import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import footer1  from '../../assets/images/Good Market Approved Logo.jpg'
import footer2  from '../../assets/images/People and Planet First Logo.webp'
import AOS from "aos";
import "aos/dist/aos.css";
import "./event.css";
function Footer() {
  useEffect(() => {
    AOS.init({ duration: 3000 });
  }, []);

  return (
    <>
      <footer className="section-widget footer-con" data-aos="fade-right">
        <div className="container">
          <div className="row">
          <div className="col-md-3">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
                 <img src={footer2} alt="Logo 2" style={{ width: "100px" }} />
              <img src={footer1} alt="Logo 1" style={{ width: "100px" }} />
            </div>
          </div>
            <div className="col-md-2">
              <h5>Quick Links</h5>
              <ul className="footerLinks colLinks  font">
                <li>
                  <Link to="/conference/why-the-connectar">Why The Connectar</Link>
                </li>
                <li>
                  <Link to="/conference/why-you-should">Data Insights</Link>
                </li>
                <li>
                  <Link to="/conference/methodology">Our Methodology</Link>
                </li>
                <li>
                  <Link to="/conference/whynow">Why Act Now</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              <h5>Company</h5>
              <ul className="footerLinks font">
                <li>
                  <Link to="/conference/privacypolice">Privacy Policy</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              <h5>Get In Touch</h5>
              <ul className="footerLinks font">
                <li>
                  <Link  to={
                   '/conference/contact'
                  }>Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <h5>Address</h5>
              <ul class="footerLinks font">
                <li>Ground Floor, 470 St Kilda Road, Melbourne, Vic Australia 3004</li>
              </ul>
            </div>
          </div>
          <div className="font bottom">&copy; 2024 the connectar. All rights reserved.</div>
        </div>
      </footer>
      {/* Back to top button */}
      {/* <div className="back-to-top" onClick={scrollToTop}>
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </div> */}
      {/* Svg Icons  */}
      <svg xmlns="http://www.w3.org/2000/svg" style={{ display: "none" }}>
        <symbol id="facebook-icon" viewBox="0 0 24 24">
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M12 1.25C6.07 1.25 1.25 6.07 1.25 12C1.25 17.33 5.07001 21.79 10.32 22.62C10.54 22.66 10.76 22.59 10.92 22.45C11.09 22.31 11.18 22.1 11.18 21.88V15C11.18 14.59 10.84 14.25 10.43 14.25H8.75999V12.75H10.43C10.84 12.75 11.18 12.41 11.18 12V9.8C11.18 7.28 12.83 6.75 14.21 6.75C14.74 6.75 15.29 6.80001 15.7 6.85001V7.81H15.19C13.72 7.81 12.81 8.7 12.81 10.12V12C12.81 12.41 13.15 12.75 13.56 12.75H15.58L15.35 14.25H13.56C13.15 14.25 12.81 14.59 12.81 15V21.88C12.81 22.1 12.91 22.31 13.07 22.45C13.21 22.57 13.38 22.63 13.56 22.63C13.6 22.63 13.64 22.63 13.68 22.63C18.94 21.81 22.75 17.34 22.75 12.01C22.75 6.07999 17.93 1.25999 12 1.25999V1.25ZM14.31 20.96V15.75H16C16.37 15.75 16.69 15.48 16.74 15.11L17.19 12.11C17.22 11.89 17.16 11.67 17.02 11.51C16.88 11.35 16.67 11.25 16.45 11.25H14.31V10.12C14.31 9.54 14.56 9.31 15.19 9.31H16.45C16.86 9.31 17.2 8.97 17.2 8.56V6.19C17.2 5.82 16.94 5.51 16.58 5.45C16.53 5.45 15.36 5.24001 14.22 5.24001C11.43 5.24001 9.69 6.97999 9.69 9.78999V11.24H8.02C7.61 11.24 7.27 11.58 7.27 11.99V14.99C7.27 15.4 7.61 15.74 8.02 15.74H9.69V20.95C5.62 19.91 2.75 16.28 2.75 11.99C2.75 6.89001 6.9 2.74001 12 2.74001C17.1 2.74001 21.25 6.89001 21.25 11.99C21.25 16.28 18.38 19.91 14.31 20.95V20.96Z"
            fill="currentColor"
          />
        </symbol>

        <symbol id="x-icon" viewBox="0 0 19 20">
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M0 0.879883L7.03781 11.1399L0.149062 19.1199H1.67531L7.71187 12.1224L12.5119 19.1199H18.2784L10.9256 8.40144L17.4141 0.879883H15.8925L10.2506 7.41613L5.76656 0.879883H0ZM1.8225 1.83988H5.26125L16.4559 18.1599H13.0172L1.8225 1.83988Z"
            fill="currentColor"
          />
        </symbol>
        <symbol id="linkedin-icon" viewBox="0 0 25 24">
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M7.31832 8.88003H3.52833C3.11833 8.88003 2.77833 9.22003 2.77833 9.63003V21C2.77833 21.41 3.11833 21.75 3.52833 21.75H7.31832C7.72832 21.75 8.06832 21.41 8.06832 21V9.63003C8.06832 9.22003 7.72832 8.88003 7.31832 8.88003ZM6.56832 20.25H4.27833V10.38H6.56832V20.25ZM5.56832 2.25002C4.76832 2.23002 4.02833 2.51002 3.44833 3.06002C2.87833 3.60002 2.54834 4.34003 2.51834 5.13003C2.49834 5.92003 2.77833 6.67002 3.32833 7.25002C3.86833 7.82002 4.60832 8.15002 5.39832 8.18002C5.41832 8.18002 5.42833 8.18002 5.44833 8.18002C7.07833 8.18002 8.41833 6.86003 8.44833 5.22003C8.44833 3.61003 7.18832 2.31002 5.56832 2.26002V2.25002ZM5.44833 6.67002H5.43833C5.04833 6.66002 4.68832 6.50003 4.42832 6.21003C4.15832 5.93003 4.01833 5.56002 4.02833 5.17002C4.03833 4.78002 4.19834 4.42002 4.48834 4.15002C4.76834 3.88002 5.12833 3.75002 5.52833 3.75002C6.32833 3.77002 6.94833 4.41002 6.94833 5.20002C6.93833 6.02002 6.26833 6.67002 5.44833 6.67002ZM21.9783 14.13C21.9783 10.17 19.3983 8.76002 17.0083 8.76002C16.0483 8.72002 15.0983 9.00002 14.3083 9.51002C14.2483 9.15002 13.9383 8.88003 13.5683 8.88003H9.90833C9.49833 8.88003 9.15833 9.22003 9.15833 9.63003V21C9.15833 21.41 9.49833 21.75 9.90833 21.75H13.6983C14.1083 21.75 14.4483 21.41 14.4483 21V15.01C14.4483 15.01 14.4483 14.91 14.4483 14.86C14.4183 14.47 14.5483 14.1 14.8083 13.81C15.0583 13.52 15.4183 13.34 15.7483 13.32C16.0483 13.32 16.7383 13.32 16.7383 15.01V21C16.7383 21.41 17.0783 21.75 17.4883 21.75H21.2783C21.4783 21.75 21.6683 21.67 21.8083 21.53C21.9483 21.39 22.0283 21.2 22.0283 21L21.9783 14.13ZM18.2383 20.25V15.01C18.2383 12.14 16.5083 11.82 15.6983 11.82C14.9083 11.87 14.1983 12.23 13.6783 12.82C13.1583 13.41 12.9083 14.17 12.9483 14.9C12.9483 14.99 12.9483 15.07 12.9483 15.09V20.24H10.6583V10.37H12.8183V11.26C12.8183 11.59 13.0383 11.88 13.3583 11.98C13.6783 12.08 14.0183 11.95 14.1983 11.67C14.7983 10.75 15.8583 10.21 16.9783 10.24C18.0283 10.24 20.4683 10.62 20.4683 14.12L20.5083 20.24H18.2283L18.2383 20.25Z"
            fill="currentColor"
          />
        </symbol>
        <symbol id="yt-icon" viewBox="0 0 25 24">
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M22.5883 6.99977C22.2883 5.87977 21.4083 4.99977 20.2883 4.69977C18.6783 4.26977 12.9283 4.25977 12.2783 4.25977C11.6283 4.25977 5.87831 4.26977 4.26831 4.69977C3.14831 4.99977 2.26832 5.87977 1.96832 6.99977C1.52832 8.63977 1.52832 11.8798 1.52832 12.0198C1.52832 12.1598 1.52832 15.3998 1.96832 17.0398C2.25832 18.1398 3.14831 19.0098 4.26831 19.3098C5.87831 19.7398 11.6283 19.7498 12.2783 19.7498C12.9283 19.7498 18.6783 19.7398 20.2883 19.3098C21.4083 19.0098 22.2983 18.1398 22.5883 17.0398C23.0283 15.3998 23.0283 12.1598 23.0283 12.0198C23.0283 11.8798 23.0283 8.63977 22.5883 6.99977ZM21.1383 16.6498C20.9783 17.2398 20.5183 17.6998 19.8983 17.8598C18.6983 18.1798 13.9883 18.2498 12.2783 18.2498C10.5683 18.2498 5.85833 18.1798 4.65833 17.8598C4.03833 17.6898 3.57834 17.2398 3.41833 16.6498C3.02833 15.1998 3.02832 12.0498 3.02832 12.0198C3.02832 11.9898 3.02833 8.83977 3.41833 7.38977C3.57834 6.78977 4.05833 6.30977 4.65833 6.14977C5.85833 5.82977 10.5683 5.75977 12.2783 5.75977C13.9883 5.75977 18.6983 5.82977 19.8983 6.14977C20.4983 6.30977 20.9783 6.78977 21.1383 7.38977C21.5283 8.83977 21.5283 11.9898 21.5283 12.0198C21.5283 12.0498 21.5283 15.1998 21.1383 16.6498ZM10.2783 8.99977L15.2783 11.9998L10.2783 14.9998V8.99977Z"
            fill="currentColor"
          />
        </symbol>
      </svg>
    </>
  );
}

export default Footer;
